/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savesocialmedialinks3Inputs */

const en_savesocialmedialinks3 = /** @type {(inputs: Savesocialmedialinks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Social Media Links`)
};

const de_savesocialmedialinks3 = /** @type {(inputs: Savesocialmedialinks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social-Media-Links speichern`)
};

/**
* | output |
* | --- |
* | "Save Social Media Links" |
*
* @param {Savesocialmedialinks3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savesocialmedialinks3 = /** @type {((inputs?: Savesocialmedialinks3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savesocialmedialinks3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savesocialmedialinks3(inputs)
	return de_savesocialmedialinks3(inputs)
});
export { savesocialmedialinks3 as "saveSocialMediaLinks" }